
import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_URL ) {
  API_URL = process.env.REACT_APP_API_URL;
}

// Requests
const requests = {
  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  },

  post: (url: string, body: any) => {
    return axios.post(API_URL + url, body);
  }
};

const directOfferAPI = {
  createStat: (application_company_id: number, webservice_id: number, event_type: string) => {
    const data = {
      direct_offer_stat: {
        application_company_id,
        webservice_id,
        event_type
      }
    }

    return requests.post(RoutesAPI.create_stat(), data);
  },
}

export default directOfferAPI;



// WEBPACK FOOTER //
// ./src/api/directOffersAPI.js